import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getProducts as getProductsApi,
  deleteProducts as deleteProductsApi,
  addNewProduct as addNewProductApi,
  updateProduct as updateProductApi,
  setProductFlag as setProductFlagApi,
  getProductById as getProductByIdApi,
  getHotProducts as getHotProductsApi,
  getMyProducts as getMyProductsApi,
  downloadProducts as downloadProductsApi,
} from "../../apiCalls/caller";

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (data) => {
    try {
      return getProductsApi(data);
    } catch (error) {
      return error;
    }
  }
);

export const getProductById = createAsyncThunk(
  "products/getProductById",
  async (data) => {
    try {
      toast.dismiss();
      toast.success("Loading product...", {
        position: "top-center",
        autoClose: 3000,
      });
      const response = await getProductByIdApi(data);
      toast.dismiss();      
      if (response.data === null) {
        toast.error("Product inexistent", {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getHotProducts = createAsyncThunk(
  "products/getHotProducts",
  async (data) => {
    try {
      return getHotProductsApi(data);
    } catch (error) {
      return error;
    }
  }
);

export const getMyProducts = createAsyncThunk(
  "products/getMyProducts",
  async (data) => {
    try {
      return getMyProductsApi(data);
    } catch (error) {
      return error;
    }
  }
);

export const deleteProducts = createAsyncThunk(
  "products/deleteProducts",
  async (product) => {
    try {
      toast.dismiss();
      toast.success("Product Delete Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      const response = deleteProductsApi(product);

      return { product, ...response };
    } catch (error) {
      toast.dismiss();
      toast.error("Product Delete Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const addNewProduct = createAsyncThunk(
  "products/addNewProduct",
  async (product) => {
    try {
      const response = addNewProductApi(product);
      const data = await response;
      toast.success("Product Added Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Product Added Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async (product) => {
    try {
      const response = updateProductApi(product);
      const data = await response;
      toast.success("Product Updateded Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return data;
    } catch (error) {
      toast.error("Product Updateded Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const setProductFlag = createAsyncThunk(
  "products/setProductFlag",
  async (data) => {
    try {
      const response = setProductFlagApi(data);
      const resultData = await response;
      toast.success("Process Successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      return resultData;
    } catch (error) {
      toast.error("Process Failed", {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const downloadProducts = createAsyncThunk(
  "products/downloadProducts",
  async (data) => {
    try {
      return downloadProductsApi(data);
    } catch (error) {
      return error;
    }
  }
);
